import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, NgModule } from '@angular/core';
import { Cms } from '@impact/data';
import { RichTextModule } from '../../rich-text/rich-text.module';

@Component({
    selector: 'app-rte-spot',
    template: `
        <section class="rte-spot" [class.rte-spot--narrow]="data.narrow" *ngIf="data">
            <app-rich-text *ngIf="data.text" [html]="data.text"></app-rich-text>
        </section>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
class RteSpotComponent {
       @Input() data: Cms.RichTextEditorSpot;
}

@NgModule({
    declarations: [RteSpotComponent],
    imports: [
        CommonModule,
        RichTextModule
    ]
})
class RteSpotModule {}

export const LazySpotComponent = RteSpotComponent;
